export default __webpack_public_path__ + "static/media/sentiment_satisfied.3eca05dc.svg";